import { STATUS, eur } from "@/lib/api";

export function PriceSteps({ offer, current = "bronze", compact }) {
  const tiers = ["bronze", "gold", "diamond"];
  return (
    <div data-testid={`price-steps-${offer.id}`} className="flex items-end gap-1.5">
      {tiers.map((t, i) => {
        const active = t === current;
        const s = STATUS[t];
        return (
          <div
            key={t}
            data-testid={`price-step-${t}`}
            className={`flex-1 rounded-xl border px-2 text-center transition-transform duration-200 ${active ? "scale-[1.03]" : "opacity-70"}`}
            style={{
              borderColor: active ? s.color : "rgba(255,255,255,0.08)",
              background: active ? `${s.color}22` : "rgba(255,255,255,0.03)",
              paddingTop: compact ? 6 + i * 3 : 8 + i * 5,
              paddingBottom: compact ? 6 : 8,
            }}
          >
            <p className="text-[10px] font-semibold uppercase tracking-wider" style={{ color: s.color }}>{s.label}</p>
            <p className={`font-display font-bold ${active ? "text-white" : "text-slate-300"} ${compact ? "text-sm" : "text-base"}`}>{eur(offer[`price_${t}`])}</p>
            {active && <p className="text-[9px] uppercase tracking-wide text-slate-300">il tuo prezzo</p>}
          </div>
        );
      })}
    </div>
  );
}
